import { createStyles, makeStyles } from '@material-ui/core/styles';

import { CustomModalProps } from './index';

export const useStyles = makeStyles(() =>
  createStyles({
    dialogContainer: {
      '& > .MuiDialog-container > .MuiPaper-root': {
        width: ({ width }: CustomModalProps) => width || '100%',
        height: ({ height }: CustomModalProps) => height || 'auto',
        maxWidth: 1200,
        backgroundColor: '#fff',
        '& > .MuiDialogTitle-root': {
          padding: '24px 24px 0 24px',
        },
        '& > .MuiDialogContent-root': {
          padding: 0,
          '& > div': {
            margin: 0,
          },
        },
      },
    },
  }),
);
